import { globalBaseImage, globalDarkImage } from '@flowus/common/images';
import { VITE_CDN_HOST } from 'src/env';
export const ossImagesPath = `${VITE_CDN_HOST}fe-web-app-images`;

const darkImage = { ...globalDarkImage };

const baseImage = {
  ...globalBaseImage,
  activityDialogDiver: new URL('./activity/diver-line.svg', import.meta.url).href,
  activityDialogDesc: new URL('./activity/desc.svg', import.meta.url).href,
  activityDialogDescTeam: new URL('./activity/desc-small-team.svg', import.meta.url).href,
  s102SettingHornIcon: new URL('./activity/s102SettingHornIcon.png', import.meta.url).href,
  subitemFeature: new URL('./subitem-feature.svg', import.meta.url).href,
  wikiDefaultIcon: new URL('./wiki_default.png', import.meta.url).href,
  wikiChatWelcome: new URL('./wiki-chat-welcome.png', import.meta.url).href,
  wikiEmpty: new URL('./wiki_empty.png', import.meta.url).href,
  buildinLogo: new URL('./buildin-logo.svg', import.meta.url).href,
};

if (__BUILD_IN__) {
  const buildinLoginLogoUrl = new URL('./buildin-login-logo.svg', import.meta.url).href;
  Object.assign(baseImage, {
    activityDialogDiver: new URL('./activity/buildin/diver-line.svg', import.meta.url).href,
    activityDialogDesc: new URL('./activity/buildin/desc.svg', import.meta.url).href,
    activityDialogDescTeam: new URL('./activity/buildin/desc-small-team.svg', import.meta.url).href,
    // 覆盖logo使Buildin登录页面头部使用新的buildin-login-logo
    logoBlackWide: buildinLoginLogoUrl,
    logoWhiteWide: buildinLoginLogoUrl,
    favicon: `${VITE_CDN_HOST}website-oversea/other/buildin_32.png`,
  });
}

/** 私有化部署调整 */
if (__PRIVATE__) {
  const logoUrl = `${ossImagesPath}/private/logo.png`;
  const loadingUrl = `${ossImagesPath}/private/loading.gif`;

  Object.assign(baseImage, {
    logo: logoUrl,
    logoWhite: logoUrl,
    logoBlackWide: logoUrl,
    logoWhiteWide: logoUrl,
    loadingGif: loadingUrl,
  });
}

export const Images = {
  reload: (isDarkMode: boolean) => {
    if (isDarkMode) {
      Object.assign(Images, darkImage);
    } else {
      Object.assign(Images, baseImage);
    }
  },
  ...baseImage,
};
